import BookHero from '../components/books/BookHero';
import GetYourCopy from '../components/books/GetYourCopy';
import Testimonials from '../components/shared/Testimonials';
import AboutBook from '../components/books/AboutBook';
import WhatYouLearn from '../components/books/WhatYouLearn';
import AboutAuthor from '../components/shared/AboutAuthor';
import JoinMe from '../components/shared/JoinMe';
import BeforeFooter from '../components/layout/BeforeFooter';
import ArabicEditionSection from '../components/books/ArabicEditionSection';
import book1Cover1 from '../assets/beforewegetolderCover.png';
import BookChat from '../components/books/BookChat';
import RelatedArticles from '../components/shared/RelatedArticles';



const book1 = {
  slug: 'bwgo',
  title: "Before We Get Older",
  subtitle: "The 20 Years Life Lessons",
  description: "Because no one told you there was more to learn — and some lessons are better understood before time rushes forward.",
  availability: "Available now in paperback & digital formats.",
  covers: [book1Cover1],
  previewLink: "/BEFOREWEGETOLDER-ENGLISH-PREVIEW.pdf",
  orderText: "Order Now",
  soldCount: "+ 300 copies sold in the first edition",
};
const beforeWeGetOlderContent = {
  bgColor: '#2c346b', // dark blue
  titleColor: '#fff559', // yellow
  textColor: '#ffffff', // white
  learnTitle: "What You Learn in This Book",
  learnContent: [
    [
    "Why the same situations keep happening to you",
    "How to face fear without running from it",
    "Why failing doesn't mean you're not enough",
    "How to be alone without feeling lonely",
    "The difference between knowing and actually living a lesson",
  ],
  [
    "How to sit with yourself in silence — and not panic",
    "Why self-love isn't selfish, it's necessary",
    "How to stop blaming everything but yourself",
    "Why your teenage years are your most important classroom",
    "How to carry your lessons with you as you grow older",
  ],
  ],
  learnMoreText: "and much much more..."
};

const beforeWeGetOlderBook = {
  title: "Before We Get Older",
  cover: book1Cover1,
  intro: "In 2020, on the eve of turning 20, Loubna looked back at her teenage years and realized something: school had taught her formulas and facts, but no one had taught her how to live. Before We Get Older is the book she wished she'd had — a collection of real lessons from the school of life. Raw, honest, and full of motivational reflections, it speaks to anyone who has ever felt lost between who they were and who they're becoming. Because in life, we face the exam first — and only then do we learn the lesson.",
  chapters: [
    {
      text: "Never Judge a Book by Its Cover",
      subtitle: "Never Judge a Book by Its Cover",
      description: "We're quick to form opinions — about others, about situations, and even about ourselves. Loubna opens the book by challenging you to slow down, look deeper, and question the assumptions that quietly shape your life."
    },
    {
      text: "The Art of Acceptance",
      subtitle: "The Art of Acceptance",
      description: "Some things in life won't go the way you planned — and fighting that reality only exhausts you. This chapter explores why accepting what you can't control isn't weakness, it's one of the most powerful things you can do for yourself."
    },
    {
      text: "Less Words, More Work",
      subtitle: "Less Words, More Work",
      description: "It's easy to talk about who you want to be. It's harder to actually become that person. Loubna gets real about the gap between intention and action — and why the only way forward is to start moving."
    },
    {
      text: "Be Strong and Confident",
      subtitle: "Be Strong and Confident",
      description: "Confidence isn't something you're born with — it's something you build, one hard moment at a time. This chapter is about learning to trust yourself even when everything feels uncertain."
    },
    {
      text: "Love YOU",
      subtitle: "Love YOU",
      description: "Before you can show up for anyone else, you have to show up for yourself. Loubna shares honestly about the journey to self-love — not the Instagram version, but the quiet, daily practice of choosing yourself."
    },
    {
      text: "It's Always Your Fault",
      subtitle: "It's Always Your Fault",
      description: "Not to be harsh — but to be free. When you stop blaming circumstances and start owning your choices, something shifts. This chapter is about radical responsibility and how it becomes your greatest tool for change."
    },
    {
      text: "Failure is the Beginning of Success",
      subtitle: "Failure is the Beginning of Success",
      description: "School taught us that failure is something to fear. Life teaches us it's something to study. Loubna reflects on her own stumbles and why every failure, if you let it, carries a lesson that success never could."
    },
  ],
};
const book1Testimonials = {
  type: 'book1',
  testimonials: [
    { quote: "I can t thank you enough for this book wallah ❤️ im in love im obsessed.", name: "Dorsaf" },
    { quote: "Your book is TOTALLY AWSOME✨️I like the way u explained the lessons by gaving examples —U are ✨️AMAZING✨️", name: "Marie" },
    { quote: "I'm in love with your book girl congrats i bought it yesterday and i couldn't stop reading it...", name: "Aya" },
    { quote: "it's a piece of art ❤️u did a gd job. I made reel with a quoet in ur book💗💗💗", name: "Lamis" },
    { quote: "le livre est juste magnifique le contenu assez attirant et bénéfique, le style d'écriture est trop beau et les idées sont vraiment douces.", name: "Wiam" },
    { quote: "I'm going through a stressful period and have to make LIFE CHANGING decisions, but since I started reading it helped me a lot. Sometimes you know the answer but it just takes someone to say something or to read or listen to something and this was the case for me. Thank you!", name: "Rasha" },
    { quote: "Hey loubna, a dear friend of mine gifted me your book and I just started reading it and let me tell you that I’m loving it so far 💕", name: "Chiraz" },
  ],
};

function BeforeWeGetOlder() {
  return (
    <div>
      <BookHero key={book1.slug} book={book1} />
    <GetYourCopy
  stores={{
    amazon: "https://www.amazon.com/dp/B0BLWM4WPG?ref_=pe_3052080_397514860&utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnJy-_gwNDO7Q5ViMqRs0tq08BFOTtHrBcnKay92YpKX-Gb0Sgn-XTH_HafDU_aem_cPWtiAtxgrtFETHCRHKoHQ",
    kindle: "https://www.amazon.com/dp/B0BLWM4WPG?ref_=pe_3052080_397514860&utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnJy-_gwNDO7Q5ViMqRs0tq08BFOTtHrBcnKay92YpKX-Gb0Sgn-XTH_HafDU_aem_cPWtiAtxgrtFETHCRHKoHQ",
    gumroad: "https://elbylit.gumroad.com/l/kjbehu"
  }}
  libraries={[
    { name: "Revolution Library", url: "https://www.instagram.com/librairie_de_la_revolution_/", style: "library-brown" },
    { name: "Zahra Library", url: "https://www.instagram.com/librairie_zahra_23/", style: "library-terracotta" },
     { name: "Big Deal Bookstore", url: "https://bigdealbookstore.com/book/586f4d8a-c873-45ed-ac3f-8f8f88eab447", style: "library-blue" }
  ]}
/>
      <WhatYouLearn book={beforeWeGetOlderContent} />
      <AboutBook book={beforeWeGetOlderBook} />
      <ArabicEditionSection />
      <RelatedArticles bookSlug="bwgo" bgColor="#2c346b" titleColor="#fff559" textColor="#ffffff" />
     <Testimonials book={book1Testimonials} />
      <AboutAuthor />
     <JoinMe />
     <BeforeFooter />
     <BookChat book="bwgo" />
    </div>
  );
}

export default BeforeWeGetOlder;
